import React from 'react';

const EmployeeForm = ({
    isEdit = false,
    newEmployee,
    setNewEmployee,
    predefinedPositions,
    availableManagers,
    handleAddEmployee,
    handleUpdateEmployee,
    setShowAddForm,
    setShowEditForm,
    setEditingEmployee,
    userProfile,
    shiftOptions = [],
    defaultShiftName = '',
}) => {
    const isSuper = userProfile?.role === 'super';
    return (
        <div className="modal">
        <div className='modal-content min-w-0'>
                <div className="employee-form">
                    <h3 className='pt-3 pl-3'>{isEdit ? 'Edit Employee' : 'Add New Employee'}</h3>
                    <div className='pl-1 pr-3'>
                        <p className="auto-generate-note">📝 Employee number will be auto-generated</p>
                    </div>
                    <form onSubmit={isEdit ? handleUpdateEmployee : handleAddEmployee} className='pr-3 pl-1'>
                        {/* Personal Information */}
                        <div className="form-section">
                            <h4>Personal Information</h4>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>Full Name *</label>
                                    <input
                                        type="text"
                                        placeholder="Enter full name"
                                        value={newEmployee.name}
                                        onChange={(e) => setNewEmployee({ ...newEmployee, name: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="form-field">
                                    <label>Email *</label>
                                    <input
                                        type="email"
                                        placeholder="Enter email address"
                                        value={newEmployee.email}
                                        onChange={(e) => setNewEmployee({ ...newEmployee, email: e.target.value })}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>Phone Number</label>
                                    <input
                                        type="text"
                                        placeholder="e.g., +965-12345678"
                                        value={newEmployee.phone}
                                        onChange={(e) => setNewEmployee({ ...newEmployee, phone: e.target.value })}
                                    />
                                </div>
                                <div className="form-field">
                                    <label>Passport Number</label>
                                    <input
                                        type="text"
                                        placeholder="Enter passport number"
                                        value={newEmployee.passport_number}
                                        onChange={(e) => setNewEmployee({ ...newEmployee, passport_number: e.target.value })}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Position & Department */}
                        <div className="form-section">
                            <h4>Position & Department</h4>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>Position *</label>
                                    {predefinedPositions.length > 0 ? (
                                        <select
                                            value={newEmployee.position}
                                            onChange={(e) => setNewEmployee({ ...newEmployee, position: e.target.value })}
                                            required
                                            className='max-w-[450px] w-full'
                                        >
                                            <option value="">Select Position</option>
                                            {predefinedPositions.map((position) => (
                                                <option key={position} value={position}>{position}</option>
                                            ))}
                                        </select>
                                    ) : (
                                        <input
                                            type="text"
                                            placeholder="Enter position"
                                            value={newEmployee.position}
                                            onChange={(e) => setNewEmployee({ ...newEmployee, position: e.target.value })}
                                            required
                                        />
                                    )}
                                </div>
                                <div className="form-field">
                                    <label>Department *</label>
                                    <select
                                        value={newEmployee.department}
                                        onChange={(e) => setNewEmployee({ ...newEmployee, department: e.target.value })}
                                        required
                                    >
                                        <option value="">Select Department</option>
                                        {/* Add your departments here */}
                                        <option value="Human Resources">Human Resources</option>
                                        <option value="IT">Information Technology</option>
                                        <option value="Finance">Finance</option>
                                        <option value="Operations">Operations</option>
                                        <option value="Marketing">Marketing</option>
                                        <option value="Sales">Sales</option>
                                        <option value="Administration">Administration</option>
                                        <option value="Legal">Legal</option>
                                        <option value="Customer Service">Customer Service</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>Joining Date *</label>
                                    <input
                                        type="date"
                                        value={newEmployee.joining_date}
                                        onChange={(e) => setNewEmployee({ ...newEmployee, joining_date: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="form-field">
                                    <label>Salary (KWD)</label>
                                    <input
                                        type="number"
                                        step="0.001"
                                        placeholder="Enter salary"
                                        value={newEmployee.salary}
                                        onChange={(e) => setNewEmployee({ ...newEmployee, salary: e.target.value })}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Role, Status, Group */}
                        <div className="form-section">
                            <h4>Classification & Reporting</h4>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>Role *</label>
                                    <select
                                        value={newEmployee.role}
                                        onChange={(e) => setNewEmployee({ ...newEmployee, role: e.target.value })}
                                        required
                                    >
                                        <option value="">Select Role</option>
                                        <option value="Staff">Staff</option>
                                        <option value="Manager">Manager</option>
                                        <option value="Admin">Admin</option>
                                        <option value="Super">Super</option>
                                    </select>
                                </div>
                                <div className="form-field">
                                    <label>Status *</label>
                                    <select
                                        value={newEmployee.status}
                                        onChange={(e) => setNewEmployee({ ...newEmployee, status: e.target.value })}
                                        required
                                    >
                                        <option value="Active">Active</option>
                                        <option value="On Leave">On Leave</option>
                                        <option value="Exited">Exited</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-field">
                                    <label>Employee Group *</label>
                                    <select
                                        value={newEmployee.group}
                                        onChange={(e) => setNewEmployee({ ...newEmployee, group: e.target.value })}
                                        required
                                        className='max-w-[450px] w-full'
                                    >
                                        <option value="Staff">Staff</option>
                                        <option value="Management">Management</option>
                                        <option value="BOH">BOH (Back of House)</option>
                                        <option value="FOH">FOH (Front of House)</option>
                                    </select>
                                </div>
                                <div className="form-field">
                                    <label>Grade Level *</label>
                                    <select
                                        value={newEmployee.grade}
                                        onChange={(e) => setNewEmployee({ ...newEmployee, grade: e.target.value })}
                                        required
                                        className='max-w-[450px] w-full'
                                    >
                                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(grade => (
                                            <option key={grade} value={grade}>Grade {grade}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {isSuper && (
                                <div className="form-row">
                                    <div className="form-field">
                                        <label>Shift</label>
                                        <select
                                            className="max-w-[450px] w-full"
                                            value={newEmployee.shift_id || ''}
                                            onChange={(e) =>
                                                setNewEmployee({
                                                    ...newEmployee,
                                                    shift_id: e.target.value,
                                                })
                                            }
                                        >
                                            <option value="">
                                                Default
                                                {defaultShiftName
                                                    ? ` (${defaultShiftName})`
                                                    : ''}
                                            </option>
                                            {shiftOptions.map((shift) => (
                                                <option key={shift.id} value={shift.id}>
                                                    {shift.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            )}

                            <div className="form-row">
                                <div className="form-field">
                                    <label>Reporting Manager</label>
                                    <select
                                    className='max-w-[450px] w-full'
                                        value={newEmployee.manager_id}
                                        onChange={(e) => setNewEmployee({ ...newEmployee, manager_id: e.target.value })}
                                    >
                                        <option value="">No Reporting Manager</option>
                                        {availableManagers.map(manager => (
                                            <option key={manager.id} value={manager.id}>
                                                {manager.name} ({manager.employee_no}) - {manager.position}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-field">
                                    <label>Location *</label>
                                    <select
                                        value={newEmployee.location}
                                        onChange={(e) => setNewEmployee({ ...newEmployee, location: e.target.value })}
                                        required
                                    >
                                        <option value="Kuwait">Kuwait</option>
                                        <option value="UAE">UAE</option>
                                        <option value="Saudi Arabia">Saudi Arabia</option>
                                        <option value="Qatar">Qatar</option>
                                        <option value="Bahrain">Bahrain</option>
                                        <option value="Oman">Oman</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* Actions */}
                        <div className="form-actions">
                            <button type="submit" className="submit-button">
                                {isEdit ? 'Update Employee' : 'Add Employee'}
                            </button>
                            <button
                                type="button"
                                onClick={() => {
                                    setShowAddForm(false);
                                    setShowEditForm(false);
                                    setEditingEmployee(null);
                                }}
                                className="cancel-button"
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EmployeeForm;
